module.exports = __webpack_public_path__ + "img/profile-cover.32a96313.png";